import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
const GetOrderStatusPageLoad = (OrderStatusPageLoadBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_PageLoad,
            JSON.stringify(OrderStatusPageLoadBO),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_PageLoad, response: data.response };
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const SavePreference = (SavePrefereceBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_btnSavePrefs_Click,
            JSON.stringify(SavePrefereceBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_btnSavePrefs_Click, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const RetriveData = (OrderStatusDataBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_RetrieveOrderData,
            JSON.stringify(OrderStatusDataBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_RetrieveOrderData, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
//Order Status Stored Procedure Integration Change - Deepthi
const HeaderData = (HeaderBO) => {
    
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_HeaderSP,
            JSON.stringify(HeaderBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: "HeaderData", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
//PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
const GetApproversPopupList = (ApproverListBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ApproverList,
            JSON.stringify(ApproverListBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ApproverList", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }

}
//PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
const RemainderOrderAction = (RemainderOrderBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ApprovalRemainder,
            JSON.stringify(RemainderOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ApprovalRemainder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
}
//Order Status Stored Procedure Integration Change - Deepthi
const LineData = (LineDataBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_LineLevelSP,
            JSON.stringify(LineDataBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: "LineData", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

//[2/2/2022, PC_OS_04, WW-350, Dhevanesam R]
const CancelRequest = (CancelRequestBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.CancelRequest,
            JSON.stringify(CancelRequestBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.CancelRequest, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const OrderStatusDetail = (OrderStatusBO) => {
    try {
        //;
        SDISVC.receiveFileBase64(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_OrderDetail,
            JSON.stringify(OrderStatusBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_OrderDetail, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const ExportData = (OrderStatusDataBO) => {
    try {
        //;
        SDISVC.downloadFile(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ExportToExcel,
            JSON.stringify(OrderStatusDataBO),
            "OrderStatusExport.xlsx",
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;

                        let contentData = { type: SDIConstants.methodNames.OrderStatus_ExportToExcel, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}



const ApprovalHistory = (ApprovalHistoryBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ApprovalHistory,
            JSON.stringify(ApprovalHistoryBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_ApprovalHistory, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const PODetail = (PODetailBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_PoDetails,
            JSON.stringify(PODetailBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_PoDetails, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const addFavOrderItemsTocart = async (addFavOrderItemsBO) => {
    try {
        //;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ReorderItems,
            JSON.stringify(addFavOrderItemsBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_ReorderItems, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const shipmentBOL = (SavePrefereceBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_ShipTo,
            JSON.stringify(SavePrefereceBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.OrderStatus_ShipTo, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const getPassThroughAutheURl = (getPassThroughAutheURlBO) => {
    try {
        //
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.PassThroughAuthe,
            SDIConstants.methodNames.PassThroughAuthe_PassAutheInitialize,
            JSON.stringify(getPassThroughAutheURlBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PassThroughAuthe", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
//WW-644_PC_09 (3/6/2023)-Aparna
const PickupOrderAction = (BO) => {
    try {
        //
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.MakePickupToDelivered,
            JSON.stringify(BO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PickupOrder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const reprintAction = (reprintBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.Reprint,
            JSON.stringify(reprintBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ReprintResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const getReturnDataAction = () => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.GetCoreRetunDetails,
            "",
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "coreDetailsResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const SubmitReturnAction = (CreateShipmentReponseBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.CreateShippingLabel,
            JSON.stringify(CreateShipmentReponseBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SubmitReturn", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}


//WW-1046 Start a return action method -Vishwa S
const SendMailForStartAReturn = (StartAReturnBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.SendMailForRMAReturn,
            JSON.stringify(StartAReturnBO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "StartAReturn", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const GetNotesAction = (GetNotesBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.OrderStatus,
            SDIConstants.methodNames.OrderStatus_GetNotes,
            JSON.stringify(GetNotesBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "getNotes", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
}


export {
    GetOrderStatusPageLoad, SavePreference,
    RetriveData, ApprovalHistory, PODetail,
    addFavOrderItemsTocart, ExportData, shipmentBOL,
    OrderStatusDetail, deleteFavPage, insertFavPage, getCurrentFavPage, getPassThroughAutheURl, CancelRequest, HeaderData, LineData, PickupOrderAction, reprintAction, getReturnDataAction, SubmitReturnAction
    , GetApproversPopupList,
    RemainderOrderAction,
    SendMailForStartAReturn, GetNotesAction
}